<template>
  <div class="social-container" :class="{ active: btnActive }">
    <ButtonsBaseButton
      :bg-color="bgColor"
      :text="text"
      icon-right="arrow-right"
      icon-left="share"
      :animate-right-icon="false"
      @click="btnActive = !btnActive" />
    <Transition name="social-dropdown">
      <div v-if="btnActive" class="social-dropdown">
        <ul class="social-list">
          <li v-for="(social, index) in socials" :key="social.url ?? index">
            <NuxtLink v-if="social.url" :to="social.url">
              <ImagesSvg
                v-if="social.iconName"
                :icon="(social.iconName as Icon) ?? ''"
                :width="32"
                :heigth="32" />
            </NuxtLink>
          </li>
        </ul>
      </div>
    </Transition>
  </div>
</template>

<script lang="ts" setup>
import type { Color } from '@base/types/color';
import type { FieldResponseModelOfString, ShareSocialsResponseModel } from '@api';
import type { Icon } from '@base/types/icon';

interface SocialsButtonProps {
  text: FieldResponseModelOfString;
  socials: ShareSocialsResponseModel[];
  bgColor?: Color;
}

withDefaults(defineProps<SocialsButtonProps>(), {
  bgColor: 'blue',
});

const btnActive = ref<boolean>(false);
</script>

<style lang="scss" scoped>
$this: '.btn';

.social-container {
  position: relative;
  width: fit-content;

  &.active {
    :deep(#{$this}--icon-right) {
      position: relative;
      right: px(8);
      transform: rotate(90deg);
    }
  }

  .social-dropdown {
    position: absolute;
    background-color: var(--color-white);
    top: 100%;
    left: 0;
    width: 100%;
    border: px(1) solid var(--color-blue);
    min-height: px(56);
    padding: px(12) px(4) px(8);
    border-radius: px(12);
    box-shadow: px(3) px(3) px(4) 0 rgba(0, 0, 0, 0.1);
    z-index: 10;

    &::after {
      content: '';
      position: absolute;
      width: px(24);
      height: px(24);
      background-color: var(--color-white);
      border-radius: px(4);
      transform: rotate(-45deg);
      top: px(-8);
      right: px(24);
    }

    .social-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      @include reset-list;

      a {
        display: block;
        height: px(32);

        svg {
          position: relative;
          pointer-events: none;
          height: px(32);
          margin: 0 px(12);
          background-color: var(--color-white);
          color: var(--color-black);
          z-index: 10;
          transition: 0.2s;
        }

        &:hover {
          svg {
            transform: scale(1.1);
          }
        }
      }
    }

    &-enter-active {
      transition: all 0.2s ease-out;
    }

    &-leave-active {
      transition: all 0.2s ease-in;
    }

    &-leave-to,
    &-enter-from {
      transform: translateY(-100%);
      opacity: 0;
    }
  }
}
</style>
